<template>
<table class="ot-table ot-table-dashboard ot-table-dashboard-compressed">
    <thead class="OToverHeader">
        <tr>
            <th class="OTborder-right p20  OTtableTriggerInfo">
                <span class="OTicon-extend-info"  v-on:click="toggleShowExtraAll(showExtra)" v-bind:class="{ 'OTicon-close-info': showExtra }"></span>
                <span v-show="showExtra">Hide Infos</span>
                <span v-show="!showExtra">Extend Info</span>
            </th>
            <th  colspan="3" class="OTborder-right p60">
                Jobs
            </th>
            <th class="p20">
                Documents
            </th>
           <th colspan="4" class="OTborder-right p80">
                Events
            </th> 
        </tr>
    </thead>
    <thead>
        <tr>
            <th class="OTborder-right p20">
                Info
            </th>
            <th class="p20">
                Running
            </th>
            <th class="p20">
                Completed
            </th>
            <th class="p20">
                Failed
            </th>
            <th class="p20">
                Crawled
            </th>
            <th class="p20">
                <span class="ot-icon-levels-critical" title="Critical"></span>
            </th>
            <th class="p20">
                <span class="ot-icon-levels-error"  title="Error"></span>
            </th>
            <th class="p20">
                <span class="ot-icon-levels-information"  title="Information"></span>
            </th>
            <th class="p20">
               <span class="ot-icon-levels-warning"  title="Warning"></span>
            </th>
            
            
        </tr>
    </thead>
    <tbody v-if="componentIds.length > 0">
        <CrawlerRow v-for="componentId in componentIds" :clusterId="clusterId" :componentId="componentId" :key="componentId"></CrawlerRow>
    </tbody>
    <tbody v-else>
        <tr>
            <td colspan="6" class="OTtableMessage">
                No component data is available yet for this cluster.
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr v-if="componentIds.length > 0">
            <td class="OTborder-right p20">
                Total
            </td>
            <td class="p20">
                {{ totalRunning }}
            </td>
            <td class="p20">
                {{ totalCompleted }}
            </td>
            <td class="OTborder-right p20">
                {{ totalFailed }}
            </td>
            <td class="p20">
                {{ totalCrawled }}
            </td>
            <td class="p20 ErrorColor">
               {{totalCritical }}
            </td>
            <td class="p20 ErrorColor">
               {{totalError }}
            </td>
            <td class="p20 InfoColor">
              {{ totalInfo }}
            </td>
            <td class="OTborder-right p20 WarningColor">
              {{ totalWarning }}
            </td>
            
            
        </tr>
    </tfoot>
</tbody>
</table>
</template>

<script>

import componentTablesMixin from '../../../mixins/componentsTable.js';
import TableComponentInfo from '../TableComponentInfo.vue';
import CrawlerRow from './CrawlerRow.vue';
import {mapTotals} from '../../../storeUtils/mapDatums.js';

const datumColumns = {
    'Running': 'Running',
    'Completed': 'Completed',
    'Pending': 'Pending',
    'Failed': 'Failed',
    'crawled': 'Crawled',
    'info': 'Info',
    'warning': 'Warnings',
    'error': 'Errors',
    'critical': 'Critical'
};


export default {

    mixins: [componentTablesMixin],
    props: ['clusterId'],
    components: {
        TableComponentInfo,
        CrawlerRow
    },
    data() {
        return {
            datumColumns: datumColumns,
            showExtra: false
        }
    },
    computed: {
        ...mapTotals(Object.keys(datumColumns))
    },
    methods: {
        toggleShowExtraAll(showExtraorNot) {
            if ( showExtraorNot ){
                this.showExtra = false
            }
            else{
                this.showExtra =  true
            }
            this.$emit('show-extra-info');
        }
    }

}
</script>


